/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：282
 */

module.exports = {
  tableDataTitle: "styles_tableDataTitle__3_CpW",
  backIcon: "styles_backIcon__1VS-4",
  tableDataList: "styles_tableDataList__34GAr",
  tableDataItem: "styles_tableDataItem__2Cv-w",
  icon: "styles_icon__3Sz8_",
  name: "styles_name__1FJie",
  desc: "styles_desc__3CHPU",
  yellow: "styles_yellow__1Ra12",
  active: "styles_active__1P4Kd",
  blue: "styles_blue__jYKao",
  disable: "styles_disable__2K0Ob",
  confirmBox: "styles_confirmBox__2PDeo",
  cloudSpaceConfirm: "styles_cloudSpaceConfirm__sKNr4",
  cloudSpaceTipsContent: "styles_cloudSpaceTipsContent__3S-Eq",
  imageBox: "styles_imageBox__Qn60y",
  logoImage: "styles_logoImage__3ysAs",
  arrowImage: "styles_arrowImage__2vHZT"
}
